import { getRobeData } from "xcore";
import { Product } from "xcore/types";

import NewsPage, { getNews } from ".";

export const getServerSideProps = getRobeData(({ query, cms, locale }) => ({
  pageContent: "newsPage",
  categories: [
    cms.taxonomy.list("news-categories")
  ],
  contents: [
    getNews(cms, locale ?? "en", query),
    cms.content.list<Product>("product", { perPage: 10000, fields: ["discontinuedGlob", "discontinuedReg"] })
  ]
}));

export default NewsPage;
